import { AppEnvironment } from './environment.model';

/**
 * DEFAULT / LOCAL environment.
 *
 * This is the file used by `ng serve` and `ng build --configuration development`,
 * so running the app locally targets the DEV backend at dev.iotzen.app.
 *
 * The `demo` and `production` builds swap THIS file out via `fileReplacements`
 * in angular.json (see environment.demo.ts / environment.prod.ts).
 */
export const environment: AppEnvironment = {
  name: 'local',
  production: false,
  apiBaseUrl: 'https://dev.iotzen.app',
};
